/**
 * HERE — make_model_map: dependent Make/Model UI + window.applyVinMakeModel for VIN.
 * Dependent Make / Model dropdowns from shop metafield global.make_model_map (JSON object).
 * Expects <script type="application/json" id="make-model-map-data"> with JSON object body.
 */
(function () {
  var MAP = null;

  function parseMap() {
    var el = document.getElementById("make-model-map-data");
    if (!el || !el.textContent) return null;
    try {
      var raw = el.textContent.trim();
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return typeof parsed === "object" && parsed !== null && !Array.isArray(parsed)
        ? parsed
        : null;
    } catch (e) {
      console.warn("[make-model-map] JSON parse failed", e);
      return null;
    }
  }

  function resolveMakeKey(make, map) {
    if (!make || make === "Make" || !map) return null;
    if (Object.prototype.hasOwnProperty.call(map, make)) return make;
    var lower = String(make).toLowerCase();
    for (var k in map) {
      if (Object.prototype.hasOwnProperty.call(map, k) && k.toLowerCase() === lower) {
        return k;
      }
    }
    return null;
  }

  function resolveModelValue(model, list) {
    if (!list || !model || model === "Model") return null;
    if (list.indexOf(model) !== -1) return model;
    var lower = String(model).toLowerCase();
    for (var i = 0; i < list.length; i++) {
      if (String(list[i]).toLowerCase() === lower) return list[i];
    }
    return null;
  }

  function appendMakeOption(select, text) {
    var opt = document.createElement("option");
    opt.value = text;
    if (text.length > 15) {
      opt.innerHTML = text.substring(0, 15) + "...";
      opt.title = text;
    } else {
      opt.textContent = text;
    }
    select.appendChild(opt);
  }

  function appendModelOption(select, text) {
    var opt = document.createElement("option");
    opt.value = text;
    if (text.length > 20) {
      opt.innerHTML = text.substring(0, 15) + "...";
      opt.title = text;
    } else {
      opt.textContent = text;
    }
    select.appendChild(opt);
  }

  function resetModelSelect(modelSelect, disabled) {
    while (modelSelect.options.length) {
      modelSelect.remove(0);
    }
    var ph = document.createElement("option");
    ph.value = "";
    ph.disabled = true;
    ph.selected = true;
    ph.textContent = "Model";
    modelSelect.appendChild(ph);
    modelSelect.disabled = !!disabled;
    if (disabled) {
      modelSelect.setAttribute("aria-disabled", "true");
    } else {
      modelSelect.removeAttribute("aria-disabled");
    }
  }

  function populateModelsForMake(makeKey, map, modelSelect, selectedModel) {
    resetModelSelect(modelSelect, false);
    var list = map[makeKey];
    if (!Array.isArray(list)) {
      modelSelect.disabled = true;
      return;
    }
    for (var i = 0; i < list.length; i++) {
      appendModelOption(modelSelect, list[i]);
    }
    if (selectedModel) {
      var resolved = resolveModelValue(selectedModel, list);
      if (resolved) modelSelect.value = resolved;
    }
  }

  function bindTooltips(makeSelect, modelSelect, tooltiptext, tooltiptextModel) {
    if (tooltiptext && makeSelect) {
      makeSelect.addEventListener("mouseover", function () {
        var so = this.options[this.selectedIndex];
        if (!so || !so.value) {
          tooltiptext.style.visibility = "hidden";
          return;
        }
        if (so.value.length > 15) {
          tooltiptext.textContent = so.value;
          tooltiptext.style.visibility = "visible";
        } else {
          tooltiptext.style.visibility = "hidden";
        }
      });
      makeSelect.addEventListener("mouseout", function () {
        tooltiptext.style.visibility = "hidden";
      });
    }
    if (tooltiptextModel && modelSelect) {
      modelSelect.addEventListener("mouseover", function () {
        var so = this.options[this.selectedIndex];
        if (!so || !so.value) {
          tooltiptextModel.style.visibility = "hidden";
          return;
        }
        if (so.value.length > 20) {
          tooltiptextModel.textContent = so.value;
          tooltiptextModel.style.visibility = "visible";
        } else {
          tooltiptextModel.style.visibility = "hidden";
        }
      });
      modelSelect.addEventListener("mouseout", function () {
        tooltiptextModel.style.visibility = "hidden";
      });
    }
  }

  function fallbackVinSelectUpdate(select, value) {
    if (!select || select.tagName !== "SELECT") return;
    if (select.options.length && select.options[0]) select.options[0].remove();
    var option = document.createElement("option");
    option.text = value;
    option.value = value;
    option.selected = true;
    select.insertBefore(option, select.firstChild);
  }

  function initMakeModelMapUI() {
    var makeSelect = document.getElementById("make");
    var modelSelect = document.getElementById("model");
    if (!makeSelect || !modelSelect) return;
    if (makeSelect.dataset.mmMapInit === "1") return;
    makeSelect.dataset.mmMapInit = "1";

    MAP = parseMap();
    window.__MAKE_MODEL_MAP__ = MAP;

    var tooltiptext = document.getElementById("tooltiptext");
    var tooltiptextModel = document.getElementById("tooltiptext-model");

    if (!MAP || Object.keys(MAP).length === 0) {
      console.warn("[make-model-map] Empty or missing map; dropdowns not populated.");
      resetModelSelect(modelSelect, true);
      return;
    }

    while (makeSelect.options.length > 1) {
      makeSelect.remove(1);
    }
    var keys = Object.keys(MAP);
    for (var j = 0; j < keys.length; j++) {
      appendMakeOption(makeSelect, keys[j]);
    }

    resetModelSelect(modelSelect, true);

    makeSelect.addEventListener("change", function () {
      var mk = makeSelect.value;
      var optionalBox = document.getElementById("optional-box");
      if (optionalBox) optionalBox.innerHTML = "";
      if (!mk) {
        resetModelSelect(modelSelect, true);
        return;
      }
      populateModelsForMake(mk, MAP, modelSelect, null);
    });

    bindTooltips(makeSelect, modelSelect, tooltiptext, tooltiptextModel);
  }

  function applyVinMakeModel(make, model) {
    var map = window.__MAKE_MODEL_MAP__ || parseMap();
    var makeSelect = document.getElementById("make");
    var modelSelect = document.getElementById("model");
    if (!makeSelect || !modelSelect) return;

    if (!make || make === "Make") {
      return;
    }

    if (!map || Object.keys(map).length === 0) {
      fallbackVinSelectUpdate(makeSelect, make);
      fallbackVinSelectUpdate(modelSelect, model);
      return;
    }

    var key = resolveMakeKey(make, map);
    if (!key) {
      fallbackVinSelectUpdate(makeSelect, make);
      fallbackVinSelectUpdate(modelSelect, model);
      return;
    }

    makeSelect.value = key;
    populateModelsForMake(key, map, modelSelect, model);
    if (model && model !== "Model") {
      var list = map[key];
      var resolved = resolveModelValue(model, list);
      if (resolved) {
        modelSelect.value = resolved;
      } else {
        if (modelSelect.options.length && modelSelect.options[0]) modelSelect.options[0].remove();
        var opt = document.createElement("option");
        opt.value = model;
        opt.text = model;
        opt.selected = true;
        modelSelect.insertBefore(opt, modelSelect.firstChild);
      }
    }
    modelSelect.disabled = false;
    modelSelect.removeAttribute("aria-disabled");
  }

  window.applyVinMakeModel = applyVinMakeModel;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMakeModelMapUI);
  } else {
    initMakeModelMapUI();
  }
})();
